import { z } from 'zod';
import { machineSchema } from './machine.js';
import { alarmSchema } from './alarm.js';

const baseEnvelope = z.object({
  shopId: z.string().min(1),
  timestamp: z.string().datetime({ offset: true }),
});

export const snapshotEventSchema = baseEnvelope.extend({
  type: z.literal('snapshot'),
  payload: z.object({
    machines: z.array(machineSchema),
  }),
});
export type SnapshotEvent = z.infer<typeof snapshotEventSchema>;

export const machineUpdateEventSchema = baseEnvelope.extend({
  type: z.literal('machine_update'),
  payload: z.object({
    machine: machineSchema,
  }),
});
export type MachineUpdateEvent = z.infer<typeof machineUpdateEventSchema>;

export const alarmEventSchema = baseEnvelope.extend({
  type: z.literal('alarm'),
  payload: z.object({
    machineId: z.string().min(1),
    alarm: alarmSchema,
  }),
});
export type AlarmEvent = z.infer<typeof alarmEventSchema>;

export const pingEventSchema = baseEnvelope.extend({
  type: z.literal('ping'),
  payload: z.object({}).passthrough().optional(),
});
export type PingEvent = z.infer<typeof pingEventSchema>;

export const liveEventSchema = z.discriminatedUnion('type', [
  snapshotEventSchema,
  machineUpdateEventSchema,
  alarmEventSchema,
  pingEventSchema,
]);
export type LiveEvent = z.infer<typeof liveEventSchema>;

export type LiveEventType = LiveEvent['type'];
